<template>
  <div>
    <v-form ref="form_step1">
      <v-row>
        <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 7">
          <div class="d-flex align-top" style="gap: 8px;">
            <v-combobox 
              v-model="shipment_order_AUX.sub_client" 
              name="sub_client" 
              item-title="name" 
              item-value="id"
              :items="subclients" 
              label="Punto de entrega" 
              autocomplete="off" 
              :loading="loading" 
              :disabled="disabled"
              @update:modelValue="loadDestino" 
              clearable 
              :rules="[rules.onlySelectFromList]"
              style="flex: 1;"
            ></v-combobox>
            <v-btn
              icon
              size="small"
              color="primary"
              class="mt-2"
              @click="openSubClientModal"
              :disabled="disabled || !shipment_order.client"
              :title="!shipment_order.client ? 'Seleccione un cliente primero' : 'Crear nuevo punto de entrega'"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
          <v-text-field label="Destinatario" v-model="shipment_order_AUX.receiver" :disabled="disabled"
            @blur="onInputBlur"></v-text-field>
          <v-text-field label="Dirección*" v-model="shipment_order_AUX.address" :disabled="disabled"
            @blur="onInputBlur"></v-text-field>
          <v-text-field label="Referencia de Dirección" v-model="shipment_order_AUX.reference" :disabled="disabled"
            @blur="onInputBlur"></v-text-field>
     
          <v-text-field label="Localidad*" v-model="shipment_order_AUX.location" :disabled="disabled"
            :rules="[rules.required]" @blur="onInputBlur"></v-text-field>
          <v-row>
            <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 5">
              <v-text-field label="Código Postal*" v-model="shipment_order_AUX.postal_code" :disabled="disabled"
                :rules="[rules.required]" @blur="onInputBlur"></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 7">
              <v-combobox v-model="shipment_order_AUX.provincia" name="provincia" item-title="name" item-value="id"
                :items="provincias" label="Provincia*" autocomplete="off" :disabled="disabled"
                :rules="[rules.requiredComboBox]" clearable @blur="onInputBlur"></v-combobox>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 5">
          <v-text-field label="Teléfono" v-model="shipment_order_AUX.telephone" :disabled="disabled"
            @blur="onInputBlur"></v-text-field>
            <v-text-field label="Email" v-model="shipment_order_AUX.email" :disabled="disabled"
              @blur="onInputBlur"></v-text-field>
          <v-row>
            <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 6">
              <v-text-field label="Latitud" v-model="shipment_order_AUX.lat"
                :disabled="disabled" readonly></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.display.mdAndDown ? 12 : undefined" :md="$vuetify.display.mdAndDown ? undefined : 6">
              <v-text-field label="Longitud" v-model="shipment_order_AUX.lng"
                :disabled="disabled" readonly></v-text-field>
            </v-col>
          </v-row>
          <Maps ref="mapaRef" :lat="shipment_order_AUX.lat" :lng="shipment_order_AUX.lng" :address="shipment_order_AUX.address"
            :location="shipment_order_AUX.location" :postal_code="shipment_order_AUX.postal_code"
            :provincia="shipment_order_AUX.provincia"  :disabled="disabled"
            @coordinates-updated="onCoordinatesUpdated" 
            :height="215"/>
        </v-col>
      </v-row>
    </v-form>

    <div :class="$vuetify.display.mdAndDown ? 'd-flex justify-space-between mt-4' : ''">
      <v-btn 
        v-if="step > 0" 
        @click="$emit('prev')" 
        :class="$vuetify.display.mdAndDown ? '' : 'mt-5'" 
        color="blue-grey"
      >
        Atras
      </v-btn>
      <v-btn 
        :class="$vuetify.display.mdAndDown ? '' : 'float-right mt-5'" 
        class="btn-second" 
        v-if="step < steps.length - 1" 
        @click="_next"
      >
        Siguiente
      </v-btn>
    </div>

    <!-- Modal para crear punto de entrega -->
    <ModalSubClient
      :service="subClientService"
      button_name=""
      modal_title="Nuevo Punto de Entrega"
      page_title="Punto de Entrega"
      :formBtn="'Guardar'"
      :dialog="dialogSubClient"
      @updateDialog="updateSubClientDialog"
      @loadList="loadSubclientsAfterCreate"
      :editItem="newSubClientItem"
      :isClient="false"
      :disableClientField="true"
    />
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { subClientService } from "@/libs/ws/subClientService";
import { generalService } from "@/libs/ws/generalService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import Maps from "@/components/Maps.vue";
import ModalSubClient from "@/views/SubClients/Modal.vue";

export default {
  components: { Maps, ModalSubClient },
  mixins: [ValidMixin],
  props: {
    open: Boolean,
    step: Number,
    steps: Array,
    shipment_order: Object,
    validator: Object,
    isViewModal: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    prev: Function,
    next: Function,
    updateShipmentOrderItem: Function,
  },
  data: () => ({
    shipment_order_AUX: {
      //Objeto para mostrar datos dentro del componente y evitar el mutating al padre
      sub_client: null,
      receiver: null,
      address: null,
      reference: null,
      location: null,
      postal_code: null,
      provincia: null,
      lng: null,
      lat: null,
    },
    itemEdit: null,
    itemEditIndex: null,
    subclients: [],
    provincias: [],
    loading: false,
    loadingAddress: false,
    errorAddress: null,
    dialogSubClient: false,
    newSubClientItem: {},
    subClientService: subClientService,
  }),
  watch: {},
  mounted() {
    if (this.shipment_order.id > 0) {
      this.shipment_order_AUX = { ...this.shipment_order };
    }
    this.loadProvincias();
    this.loadSubclients();
  },
  methods: {
    onInputBlur() {
      this.$refs.mapaRef.handleInputsBlur();
    },
    onCoordinatesUpdated({ lat, lng }) {
      this.shipment_order_AUX.lat = lat;
      this.shipment_order_AUX.lng = lng;
    },
    loadDestino() {
      if (this.shipment_order_AUX.sub_client) {
        this.shipment_order_AUX.receiver =
          this.shipment_order_AUX.sub_client.name;
        this.shipment_order_AUX.address =
          this.shipment_order_AUX.sub_client.address;
        this.shipment_order_AUX.reference =
          this.shipment_order_AUX.sub_client.reference;
        this.shipment_order_AUX.telephone =
          this.shipment_order_AUX.sub_client.phone;
        this.shipment_order_AUX.email =
          this.shipment_order_AUX.sub_client.mail;
        this.shipment_order_AUX.location =
          this.shipment_order_AUX.sub_client.location;
        this.shipment_order_AUX.postal_code =
          this.shipment_order_AUX.sub_client.postal_code;
        this.shipment_order_AUX.provincia =
          this.shipment_order_AUX.sub_client.provincia;
        this.shipment_order_AUX.lat = this.shipment_order_AUX.sub_client.lat;
        this.shipment_order_AUX.lng = this.shipment_order_AUX.sub_client.lng;
      }
    },
    loadProvincias() {
      generalService
        .filter({}, Constant.SECTION_PROVINCIAS)
        .then((response) => {
          this.provincias = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadSubclients() {
      if (this.disabled) return;
      this.loading = true;

      let client =
        this.shipment_order.client != null
          ? this.shipment_order.client.id
          : null;

      subClientService
        .filter({ client: client })
        .then((response) => {
          this.subclients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async _next() {
      const { valid } = await this.$refs.form_step1.validate();
      if (!valid) {
        return;
      }
      this.$emit("updateShipmentOrderItem", { ...this.shipment_order_AUX });
      this.$emit("next");
    },
    openSubClientModal() {
      // Pre-cargar el cliente seleccionado
      console.log("cliente", this.shipment_order.client);
      this.newSubClientItem = {
        id: 0,
        name: "",
        mail: "",
        phone: "",
        address: "",
        reference: "",
        location: "",
        postal_code: "",
        provincia: null,
        client: this.shipment_order.client,
        lat: null,
        lng: null
      };
      this.dialogSubClient = true;
    },
    updateSubClientDialog(value) {
      this.dialogSubClient = value;
      
      // Si se cierra el modal, resetear el item
      if (!value) {
        this.newSubClientItem = {
          id: 0,
          name: "",
          mail: "",
          phone: "",
          address: "",
          reference: "",
          email: "",
          telephone: "",
          location: "",
          postal_code: "",
          provincia: null,
          client: null,
          lat: null,
          lng: null
        };
      }
    },
    async loadSubclientsAfterCreate() {
      // Recargar la lista de puntos de entrega
      this.loading = true;
      
      let client =
        this.shipment_order.client != null
          ? this.shipment_order.client.id
          : null;

      try {
        const response = await subClientService.filter({ client: client });
        this.subclients = response.result.list;
        
        // Seleccionar automáticamente el último creado (el más reciente)
        if (this.subclients.length > 0) {
          const lastCreated = this.subclients[this.subclients.length - 1];
          this.shipment_order_AUX.sub_client = lastCreated;
          this.loadDestino();
        }
      } catch (e) {
        console.log("service.load error", e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
